import * as Yup from 'yup';
import { Form } from '@webinex/antik';
import { useOptionEntityOptionSource } from '@app/main/utils';
import { OptionInitialValue } from '@app/main/api';
import { convertOptionToSourceItems } from '@app/main/utils';

export const PROVIDER_INFO_SCHEMA = Yup.object({
  specialtyId: Yup.string().nullable().defined(),
});

export type ProviderInfoFieldSetValue = Yup.InferType<typeof PROVIDER_INFO_SCHEMA> & {
  specialty: OptionInitialValue | null;
  job?: string | null;
};

export const PROVIDER_INFO_INITIAL_VALUE: ProviderInfoFieldSetValue = {
  specialtyId: null,
  specialty: null,
};

export interface ProviderInfoFieldSetProps {
  name: string;
  initialSpecialty?: OptionInitialValue | null;
}

export function ProviderInfoFieldSet(props: ProviderInfoFieldSetProps) {
  const { name, initialSpecialty } = props;
  const specialtyOptionSource = useOptionEntityOptionSource({ discriminator: 'specialty' });
  const initialSpecialtyValues = convertOptionToSourceItems(initialSpecialty);

  return (
    <Form.Item name={`${name}.specialtyId`}>
      <Form.AsyncSelect optionSource={specialtyOptionSource} preload always={initialSpecialtyValues ?? []} />
    </Form.Item>
  );
}
